import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=352d5e70&scoped=true"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=352d5e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d5e70",
  null
  
)

export default component.exports